module.exports = __webpack_public_path__ + "static/age_check_line_bg-85e74103ef67a3a2208fbcb0d22c8d36.svg";